<div class="err-modal-header">
  <div class="modal-window__title err-modal-title">
    <mat-icon
      class="test"
      svgIcon="warning"></mat-icon>
    <span class="err-modal-title-text">{{ title | translate }}</span>
  </div>
</div>
<mat-divider></mat-divider>
<div
  *ngFor="let contentItem of content"
  class="modal-window__label err-modal-content">
  <p>
    {{ contentItem | translate }}
  </p>
</div>

<div
  *ngIf="additionalDetails?.length"
  class="err-additional-detail">
  <p class="err-additional-detail-title">
    {{ localizationConstants.ERROR_ADDITIONAL_DETAILS | translate }}
  </p>
  <div *ngFor="let data of additionalDetails">
    <p>{{ data }}</p>
  </div>
</div>
<p
  *ngIf="requestId"
  class="err-modal-request-id">
  Request Id: {{ requestId }}
</p>

<div class="err-modal-action col-12 col-md-3 u-mt--medium">
  <button
    type="submit"
    class="button--sm button-primary button-block"
    (click)="onClose()">
    {{ "button.close" | translate }}
  </button>
</div>
